import Button from "components/Buttons/Button";
import StickyBanner from "components/Common/StickyBanner";
import { PreSignupStatusEnum } from "enum/common";
import moment from "moment";
import React from "react";
import { isFutureDate } from "utils/common";

interface IPreRegisterStatusReasonProps {
  onPreRegisterClick: () => void;
  onLearnMoreClick: () => void;
  selectedBusiness: BusinessType;
  cityName: string;
}

const PreRegisterStatusReason: React.FC<IPreRegisterStatusReasonProps> = ({
  onPreRegisterClick,
  onLearnMoreClick,
  selectedBusiness,
  cityName,
}) => {
  const preSignupDetails = selectedBusiness?.preSignupDetails;
  const styles = {
    bannerContainerStyle:
      "flex gap-2 flex-col md:flex-row md:items-center px-4 text-center",
    bannerButtonStyle:
      "!px-4 !py-1 !w-fit !bg-white !text-black !self-center !my-1 ",
    cancelButtonStyle:
      "!px-4 !py-1 !w-fit !bg-transparent !text-white !self-center !border-white ",
    buttonContainerStyle: "flex gap-2 justify-center",
  };
  const renderPreSignupStatuReason = () => {
    const isFutureActivation = isFutureDate(
      selectedBusiness.preSignupDetails.activationDate
    );
    switch (preSignupDetails?.preSignupStatus) {
      case PreSignupStatusEnum.ENROLLED:
        return (
          <StickyBanner customClass="!bg-green pt-2">
            <div className={styles.bannerContainerStyle}>
              {!selectedBusiness.onboardingDate ? (
                <p>
                  Your registration has been submitted and is now pending
                  review!
                </p>
              ) : isFutureActivation ? (
                <p>
                  Hooray, you have successfully pre-registered and your plan
                  will activate on{" "}
                  {moment
                    .utc(preSignupDetails?.activationDate)
                    .format("MMM Do")}
                  !
                </p>
              ) : null}
              <div className={styles.buttonContainerStyle}>
                <Button
                  label={"View details"}
                  customClass={styles.bannerButtonStyle}
                  onClick={onLearnMoreClick}
                />
              </div>
            </div>
          </StickyBanner>
        );
      case PreSignupStatusEnum.FAILED:
      case PreSignupStatusEnum.PENDING:
      case PreSignupStatusEnum.WITHDRAWN:
        return (
          <StickyBanner customClass="!bg-brightOrange pt-2">
            <div className={styles.bannerContainerStyle}>
              <p>
                {cityName}’s sponsored program{" "}
                {isFutureActivation ? "will be ending" : "ended on"}{" "}
                {moment
                  .utc(preSignupDetails?.activationDate)
                  .subtract(1, "days")
                  .format("MMM Do")}
                . Pre-register now to stay active in the app
              </p>
              <div className={styles.buttonContainerStyle}>
                <Button
                  label={"Pre-Register"}
                  customClass={styles.bannerButtonStyle}
                  onClick={onPreRegisterClick}
                />
              </div>
            </div>
          </StickyBanner>
        );
      default:
        return null;
    }
  };
  return <div>{renderPreSignupStatuReason()}</div>;
};

export default PreRegisterStatusReason;
